import type { ReactNode } from "react";
import { IconArrowLeft } from "@tabler/icons-react";
import { Button } from "../../../components/common/button";
import AuthHeader from "../presentation/components/auth_header";

type AuthLayoutProps = {
  children: ReactNode;
  onBack?: () => void;
  headerTitle?: string;
  headerSubtitle?: string;
};

export function AuthLayout({
  children,
  onBack,
  headerTitle = "Welcome to Procurtal!",
  headerSubtitle = "",
}: AuthLayoutProps) {
  return (
    <main className="bg-bgMuted text-white min-h-screen relative">
      <div className="w-full max-w-3xl min-h-screen bg-bgDefault p-6 sm:p-8 md:p-20 relative mx-auto">
        {onBack && (
          <div className="absolute left-4 sm:left-6 top-4 sm:top-6 z-10">
            <Button
              variant="ghost"
              size="sm"
              aria-label="Back"
              leftIcon={<IconArrowLeft size={20} />}
              onClick={onBack}
            />
          </div>
        )}
        <div className="flex flex-col items-center gap-0 w-full">
          <div className="flex flex-col items-center w-full mb-6">
            <AuthHeader title={headerTitle} subtitle={headerSubtitle} />
          </div>
          {children}
        </div>
      </div>
    </main>
  );
}
